<section class="pulse-card d-flex flex-column">
  <header class="pulse-header d-flex align-items-center">
    <mat-icon class="header-icon">monitor_heart</mat-icon>
    <h2 class="header-title">{{ 'app.home.pulse.title' | translate }}</h2>

    <div class="header-meta d-flex align-items-center ms-auto">
      @if (home.deviceCount() !== null) {
      <span class="header-count">
        {{ 'app.home.pulse.device_count' | translate: { count: home.deviceCount() } }}
      </span>
      }
      @if (home.isFleetScanComplete()) {
      <button type="button" mat-icon-button class="header-action"
        [matTooltip]="'app.home.fleet.rescan' | translate" (click)="onRescan()">
        <mat-icon>refresh</mat-icon>
      </button>
      }
    </div>
  </header>

  @if (home.hasPulseData()) {
  <div class="pulse-metrics d-flex flex-column">
    @for (metric of home.pulseMetrics(); track metric.key) {
    <div class="metric">
      <div class="metric-head d-flex align-items-center">
        <mat-icon class="metric-icon">{{ metric.icon }}</mat-icon>
        <span class="metric-label">{{ metric.labelKey | translate }}</span>
        <span class="metric-value ms-auto">
          {{ 'app.home.pulse.ratio' | translate: { value: metric.value, total: metric.total } }}
        </span>
      </div>
      <div class="metric-track">
        <span class="metric-fill" [style.width.%]="toPercent(metric.ratio)"
          [attr.data-level]="levelOf(metric.ratio)"></span>
      </div>
    </div>
    }
  </div>
  }

  @if (hasOsShares()) {
  <div class="os-mix">
    <span class="os-mix-title">{{ 'app.home.pulse.os_mix' | translate }}</span>
    <div class="os-mix-bar d-flex">
      @for (share of home.osShares(); track share.name; let index = $index) {
      <span class="os-mix-segment" [style.width.%]="toPercent(share.ratio)" [attr.data-slot]="index"
        [matTooltip]="'app.home.pulse.os_share' | translate: { name: share.name, count: share.count }"></span>
      }
    </div>
    <ul class="os-mix-legend list-unstyled d-flex flex-wrap">
      @for (share of home.osShares(); track share.name; let index = $index) {
      <li class="legend-item d-flex align-items-center">
        <span class="legend-dot" [attr.data-slot]="index" aria-hidden="true"></span>
        <span class="legend-name text-truncate">{{ share.name }}</span>
        <span class="legend-count">{{ share.count }}</span>
      </li>
      }
    </ul>
  </div>
  }

  @if (home.isFleetScanPending()) {
  <div class="fleet-primer d-flex flex-column">
    <p class="primer-text">{{ 'app.home.fleet.primer' | translate }}</p>
    <span class="primer-note">{{ 'app.home.fleet.cost_note' | translate }}</span>
    <button type="button" mat-flat-button class="primer-action align-self-start" (click)="onScan()">
      <mat-icon>radar</mat-icon>
      {{ 'app.home.fleet.scan' | translate }}
    </button>
  </div>
  }

  @if (isStepListVisible()) {
  <ol class="fleet-steps list-unstyled">
    @for (step of home.fleetSteps(); track step.stage) {
    <li class="fleet-step d-flex align-items-center" [attr.data-state]="step.state">
      <span class="step-marker d-flex align-items-center justify-content-center flex-shrink-0">
        @if (step.state === 'running') {
        <mat-progress-spinner mode="indeterminate" diameter="16" />
        } @else if (step.state === 'done') {
        <mat-icon>check</mat-icon>
        } @else if (step.state === 'failed') {
        <mat-icon>priority_high</mat-icon>
        } @else {
        <mat-icon>{{ step.icon }}</mat-icon>
        }
      </span>
      <span class="step-label">{{ step.labelKey | translate }}</span>
      @if (step.state === 'failed') {
      <span class="step-state ms-auto">{{ 'app.home.fleet.step_failed' | translate }}</span>
      }
    </li>
    }
  </ol>
  }

  @if (isEmptyStateVisible()) {
  <div class="pulse-empty d-flex flex-column align-items-center text-center">
    <mat-icon>insights</mat-icon>
    <span>{{ 'app.home.pulse.empty' | translate }}</span>
  </div>
  }
</section>
